(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-modular-bundle"]) return;
  try {
    
  if (!customElements.get('modular-bundle-builder')) {
    customElements.define(
      'modular-bundle-builder',
      class ModularBundleBuilder extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.grid = this.querySelector('[data-bundle-grid]');
          this.notice = this.querySelector('[data-bundle-notice]');
          this.bar = this.querySelector('[data-bundle-bar]');
          this.submitButton = this.querySelector('[data-bundle-submit]');
          this.countNode = this.querySelector('[data-bundle-count]');
          this.subtotalNode = this.querySelector('[data-bundle-subtotal]');
          this.preview = this.querySelector('[data-bundle-preview]');
          this.previewList = this.querySelector('[data-bundle-preview-list]');
          this.previewToggle = this.querySelector('[data-bundle-preview-toggle]');
          this.journeySteps = [...this.querySelectorAll('[data-bundle-step]')];
          if (!this.grid || !this.bar) return;

          try {
            this.config = JSON.parse(this.querySelector('[data-bundle-config]').textContent);
          } catch (error) {
            return;
          }

          this.strings = this.config.strings;
          const variantRulesResult = this.normalizeVariantRules(this.config.variantRules);
          const bundleFixedPropertyResult = this.normalizeBundleFixedLineItemProperties(
            this.config.bundleFixedLineItemProperties,
            this.config.products || []
          );
          this.variantRules = variantRulesResult.rules;
          this.products = (this.config.products || []).map((product) =>
            this.normalizeProduct(
              product,
              this.variantRules.get(product.handle),
              variantRulesResult.error,
              bundleFixedPropertyResult.configurations.get(this.normalizePropertyToken(product.handle)),
              bundleFixedPropertyResult.error
            )
          );
          this.productsByHandle = new Map(this.products.map((product) => [product.handle, product]));
          this.entries = [];
          this.openProducts = new Set();
          this.hasTriedSubmit = false;
          this.isSubmitting = false;
          this.keyIndex = 0;

          this.products.forEach((product) => {
            if (product.defaultSelected && product.usable) this.entries.push(this.createEntry(product));
          });

          const firstIncomplete = this.entries.find((entry) => !this.entryComplete(entry));
          if (firstIncomplete) this.openProducts.add(firstIncomplete.productHandle);

          this.bindEvents();
          this.bar.hidden = false;
          this.render();
          this.boundScheduleBarDock = () => this.scheduleBarDock();
          window.addEventListener('scroll', this.boundScheduleBarDock, { passive: true });
          window.addEventListener('resize', this.boundScheduleBarDock, { passive: true });
          window.visualViewport?.addEventListener('resize', this.boundScheduleBarDock, { passive: true });
          window.visualViewport?.addEventListener('scroll', this.boundScheduleBarDock, { passive: true });
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.boundScheduleBarDock, { once: true });
          }
          this.scheduleBarDock();
        }

        disconnectedCallback() {
          window.clearTimeout(this.fieldRenderTimer);
          if (!this.boundScheduleBarDock) return;
          window.removeEventListener('scroll', this.boundScheduleBarDock);
          window.removeEventListener('resize', this.boundScheduleBarDock);
          window.visualViewport?.removeEventListener('resize', this.boundScheduleBarDock);
          window.visualViewport?.removeEventListener('scroll', this.boundScheduleBarDock);
          document.removeEventListener('DOMContentLoaded', this.boundScheduleBarDock);
          if (this.barDockFrame) cancelAnimationFrame(this.barDockFrame);
          document.documentElement.style.removeProperty('--bundle-visual-top');
          this.bar?.setAttribute('hidden', '');
        }

        normalizeVariantRules(rawRules) {
          if (rawRules === null || rawRules === undefined) return { rules: new Map(), error: '' };
          if (typeof rawRules !== 'object' || Array.isArray(rawRules)) {
            return { rules: new Map(), error: 'Bundle variant rules must be a JSON object keyed by product handle.' };
          }
          return {
            rules: new Map(
              Object.entries(rawRules).map(([handle, rule]) => [String(handle).trim().toLowerCase(), rule])
            ),
            error: '',
          };
        }

        normalizeBundleFixedLineItemProperties(rawConfigurations, rawProducts) {
          if (rawConfigurations === null || rawConfigurations === undefined) {
            return { configurations: new Map(), error: '' };
          }
          if (!this.isPlainObject(rawConfigurations)) {
            return {
              configurations: new Map(),
              error: 'Bundle fixed line-item properties must be a JSON object keyed by product handle.',
            };
          }

          const knownHandles = new Set(
            rawProducts.map((product) => this.normalizePropertyToken(product.handle)).filter(Boolean)
          );
          const configurations = new Map();
          for (const [rawHandle, configuration] of Object.entries(rawConfigurations)) {
            const handle = String(rawHandle || '').trim();
            const canonicalHandle = this.normalizePropertyToken(handle);
            if (!handle) {
              return { configurations: new Map(), error: 'Bundle fixed line-item properties contain a blank handle.' };
            }
            if (configurations.has(canonicalHandle)) {
              return {
                configurations: new Map(),
                error: `Bundle fixed line-item properties repeat the handle ${handle}.`,
              };
            }
            if (!knownHandles.has(canonicalHandle)) {
              return {
                configurations: new Map(),
                error: `Bundle fixed line-item properties reference an unknown product handle: ${handle}.`,
              };
            }
            configurations.set(canonicalHandle, configuration);
          }
          return { configurations, error: '' };
        }

        normalizeProduct(
          rawProduct,
          rawVariantRule,
          variantRulesError,
          rawBundleFixedLineItemProperties,
          bundleFixedLineItemPropertiesError
        ) {
          const allowedIdList = (rawProduct.allowedVariantIds || []).map(Number);
          const allowedIds = new Set(allowedIdList);
          const baselineVariants = (rawProduct.variants || [])
            .map((variant) => ({
              id: Number(variant.id),
              title: String(variant.title || ''),
              price: Number(variant.price || 0),
              available: Boolean(variant.available),
              options: Array.isArray(variant.options)
                ? variant.options.map(String)
                : [variant.option1, variant.option2, variant.option3].filter(Boolean).map(String),
              image: this.variantImage(variant),
            }))
            .filter((variant) => variant.available && (allowedIds.size === 0 || allowedIds.has(variant.id)))
            .sort((left, right) => {
              if (allowedIdList.length === 0) return 0;
              return allowedIdList.indexOf(left.id) - allowedIdList.indexOf(right.id);
            });

          const fieldResult = this.normalizeFields(rawProduct.personalization);
          const fixedPropertyResult = this.normalizeFixedLineItemProperties(
            rawProduct.fixedLineItemProperties,
            rawProduct.optionNames,
            rawProduct.variants
          );
          const bundleFixedPropertyResult = this.normalizeFixedLineItemProperties(
            rawBundleFixedLineItemProperties,
            rawProduct.optionNames,
            rawProduct.variants
          );
          const variantRuleResult = this.applyVariantRule(rawProduct, baselineVariants, rawVariantRule);
          const configError = [
            variantRulesError,
            bundleFixedLineItemPropertiesError,
            variantRuleResult.error,
            fieldResult.error,
            fixedPropertyResult.error,
            bundleFixedPropertyResult.error,
          ].filter(Boolean).join(' ');
          return {
            ...rawProduct,
            variants: variantRuleResult.variants,
            fields: fieldResult.fields,
            fixedLineItemProperties: fixedPropertyResult.configuration,
            bundleFixedLineItemProperties: bundleFixedPropertyResult.configuration,
            configError,
            usable: variantRuleResult.variants.length > 0 && !configError,
          };
        }

        applyVariantRule(rawProduct, variants, rawRule) {
          if (rawRule === null || rawRule === undefined) return { variants, error: '' };
          if (typeof rawRule !== 'object' || Array.isArray(rawRule)) {
            return { variants: [], error: `The rule for ${rawProduct.handle} must be an object.` };
          }

          const optionNames = (rawProduct.optionNames || []).map((name) => String(name));
          const filters = [];
          for (const [requestedName, requestedValues] of Object.entries(rawRule)) {
            const optionIndex = optionNames.findIndex(
              (name) => name.trim().toLowerCase() === String(requestedName).trim().toLowerCase()
            );
            if (optionIndex === -1) {
              return { variants: [], error: `${rawProduct.title} has no option named ${requestedName}.` };
            }

            const values = Array.isArray(requestedValues) ? requestedValues : [requestedValues];
            const normalizedValues = [...new Set(values.map((value) => String(value).trim().toLowerCase()).filter(Boolean))];
            if (normalizedValues.length === 0) {
              return { variants: [], error: `${requestedName} needs at least one allowed value.` };
            }

            const knownValues = new Set(
              (rawProduct.variants || [])
                .map((variant) => String((variant.options || [])[optionIndex] || '').trim().toLowerCase())
                .filter(Boolean)
            );
            const unknownValue = normalizedValues.find((value) => !knownValues.has(value));
            if (unknownValue) {
              return { variants: [], error: `${rawProduct.title} has no ${requestedName} value named ${unknownValue}.` };
            }
            filters.push({ optionIndex, values: new Set(normalizedValues) });
          }

          const filteredVariants = variants.filter((variant) =>
            filters.every((filter) => filter.values.has(String(variant.options[filter.optionIndex] || '').trim().toLowerCase()))
          );
          return { variants: filteredVariants, error: '' };
        }

        normalizeFields(personalization) {
          if (personalization === null || personalization === undefined) return { fields: [], error: '' };
          if (typeof personalization !== 'object' || Array.isArray(personalization) || !Array.isArray(personalization.fields)) {
            return { fields: [], error: 'Expected an object with a fields array.' };
          }

          const supportedTypes = new Set(['text', 'textarea', 'date', 'select']);
          const seenKeys = new Set();
          const seenLabels = new Set();
          const fields = [];

          for (const rawField of personalization.fields) {
            if (!rawField || typeof rawField !== 'object' || Array.isArray(rawField)) {
              return { fields: [], error: 'Every field must be an object.' };
            }

            const key = String(rawField.key || '').trim();
            const label = String(rawField.label || '').trim();
            const type = String(rawField.type || 'text').trim().toLowerCase();
            if (!key || !label) return { fields: [], error: 'Every field needs a key and label.' };
            if (seenKeys.has(key)) return { fields: [], error: `Duplicate field key: ${key}` };
            if (seenLabels.has(label.toLowerCase())) return { fields: [], error: `Duplicate field label: ${label}` };
            if (label.startsWith('_')) return { fields: [], error: `${label} cannot begin with an underscore.` };
            if (!supportedTypes.has(type)) return { fields: [], error: `Unsupported field type: ${type}` };

            let options = [];
            if (type === 'select') {
              if (!Array.isArray(rawField.options)) return { fields: [], error: `${label} needs an options array.` };
              options = [...new Set(rawField.options.map((option) => String(option).trim()).filter(Boolean))];
              if (options.length === 0) return { fields: [], error: `${label} needs at least one option.` };
            }

            const requestedLength = Number(rawField.max_length || 40);
            const maxLength = Number.isFinite(requestedLength) && requestedLength > 0 ? Math.min(requestedLength, 200) : 40;
            fields.push({
              key,
              label,
              type,
              required: rawField.required === true,
              placeholder: String(rawField.placeholder || ''),
              maxLength,
              options,
            });
            seenKeys.add(key);
            seenLabels.add(label.toLowerCase());
          }

          return { fields, error: '' };
        }

        normalizeFixedLineItemProperties(rawConfiguration, rawOptionNames, rawVariants) {
          if (rawConfiguration === null || rawConfiguration === undefined) {
            return { configuration: null, error: '' };
          }

          try {
            if (!this.isPlainObject(rawConfiguration)) {
              throw new Error('Fixed line-item properties must be a JSON object.');
            }
            this.validateObjectKeys(
              rawConfiguration,
              new Set(['defaults', 'rules']),
              'Fixed line-item properties'
            );

            const optionNames = Array.isArray(rawOptionNames)
              ? rawOptionNames.map((name) => String(name || '').trim())
              : [];
            const variants = Array.isArray(rawVariants) ? rawVariants : [];
            if (optionNames.some((name) => !name) || variants.length === 0) {
              throw new Error('Product option data is missing.');
            }

            const knownValues = optionNames.map(() => new Set());
            variants.forEach((variant) => {
              const options = Array.isArray(variant.options)
                ? variant.options.map((value) => String(value || '').trim())
                : [];
              if (options.length !== optionNames.length) {
                throw new Error('A product variant has invalid option data.');
              }
              options.forEach((value, index) => {
                if (value) knownValues[index].add(this.normalizePropertyToken(value));
              });
            });

            const defaults = rawConfiguration.defaults === undefined
              ? []
              : this.normalizeFixedPropertyEntries(rawConfiguration.defaults, 'defaults');
            if (rawConfiguration.rules !== undefined && !Array.isArray(rawConfiguration.rules)) {
              throw new Error('rules must be an array.');
            }

            const rules = (rawConfiguration.rules || []).map((rawRule, ruleIndex) => {
              const context = `rules[${ruleIndex}]`;
              if (!this.isPlainObject(rawRule)) throw new Error(`${context} must be an object.`);
              this.validateObjectKeys(rawRule, new Set(['when', 'properties']), context);
              if (!this.isPlainObject(rawRule.when) || Object.keys(rawRule.when).length === 0) {
                throw new Error(`${context}.when must contain at least one product option.`);
              }

              const usedOptionIndexes = new Set();
              const conditions = Object.entries(rawRule.when).map(([requestedName, requestedValues]) => {
                const optionIndex = optionNames.findIndex(
                  (optionName) => this.normalizePropertyToken(optionName) === this.normalizePropertyToken(requestedName)
                );
                if (optionIndex === -1) throw new Error(`${context} references an unknown option: ${requestedName}.`);
                if (usedOptionIndexes.has(optionIndex)) {
                  throw new Error(`${context} repeats the option ${optionNames[optionIndex]}.`);
                }

                const values = Array.isArray(requestedValues) ? requestedValues : [requestedValues];
                const normalizedValues = new Set();
                values.forEach((value) => {
                  if (typeof value !== 'string' || !value.trim()) {
                    throw new Error(`${context}.${requestedName} must contain nonblank strings.`);
                  }
                  const normalizedValue = this.normalizePropertyToken(value);
                  if (!knownValues[optionIndex].has(normalizedValue)) {
                    throw new Error(`${context} references an unknown ${optionNames[optionIndex]} value: ${value}.`);
                  }
                  normalizedValues.add(normalizedValue);
                });
                if (normalizedValues.size === 0) {
                  throw new Error(`${context}.${requestedName} needs at least one value.`);
                }
                usedOptionIndexes.add(optionIndex);
                return { optionIndex, values: normalizedValues };
              });

              const properties = this.normalizeFixedPropertyEntries(rawRule.properties, `${context}.properties`);
              if (properties.length === 0) throw new Error(`${context}.properties cannot be empty.`);
              return { conditions, properties };
            });

            if (defaults.length === 0 && rules.length === 0) {
              throw new Error('Fixed line-item properties must contain defaults or rules.');
            }
            return { configuration: { defaults, rules }, error: '' };
          } catch (error) {
            return { configuration: null, error: error.message || 'Invalid fixed line-item properties.' };
          }
        }

        normalizeFixedPropertyEntries(rawProperties, context) {
          if (!this.isPlainObject(rawProperties)) {
            throw new Error(`${context} must be an object of property labels and values.`);
          }

          const entries = [];
          const seenLabels = new Set();
          Object.entries(rawProperties).forEach(([rawLabel, rawValue]) => {
            const label = String(rawLabel || '').trim();
            const canonicalLabel = this.normalizePropertyToken(label);
            if (!label) throw new Error(`${context} contains a blank property label.`);
            if (label.startsWith('_')) {
              throw new Error(`${context} property labels cannot begin with an underscore.`);
            }
            if (seenLabels.has(canonicalLabel)) {
              throw new Error(`${context} contains a duplicate property label: ${label}.`);
            }
            if (typeof rawValue !== 'string' || !rawValue.trim()) {
              throw new Error(`${context}.${label} must be a nonblank string.`);
            }
            entries.push({ label, canonicalLabel, value: rawValue.trim() });
            seenLabels.add(canonicalLabel);
          });
          return entries;
        }

        resolveFixedLineItemProperties(configuration, variant) {
          if (!configuration || !variant) return [];
          const resolved = new Map();
          const applyEntries = (entries) => {
            entries.forEach((entry) => {
              const existing = resolved.get(entry.canonicalLabel);
              if (existing) existing.value = entry.value;
              else resolved.set(entry.canonicalLabel, { ...entry });
            });
          };

          applyEntries(configuration.defaults);
          configuration.rules.forEach((rule) => {
            const matches = rule.conditions.every((condition) =>
              condition.values.has(this.normalizePropertyToken(variant.options[condition.optionIndex]))
            );
            if (matches) applyEntries(rule.properties);
          });
          return [...resolved.values()];
        }

        isPlainObject(value) {
          return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
        }

        validateObjectKeys(value, allowedKeys, context) {
          const unknownKey = Object.keys(value).find((key) => !allowedKeys.has(key));
          if (unknownKey) throw new Error(`${context} contains an unsupported key: ${unknownKey}.`);
        }

        normalizePropertyToken(value) {
          return String(value || '').trim().toLowerCase();
        }

        variantImage(variant) {
          const image = variant.featured_image || variant.featured_media?.preview_image;
          if (!image) return '';
          if (typeof image === 'string') return image;
          return String(image.src || image.url || '');
        }

        bindEvents() {
          this.grid.addEventListener('click', (event) => {
            const selectButton = event.target.closest('[data-select-product]');
            if (selectButton) return this.selectProduct(selectButton.dataset.selectProduct);

            const toggleProductButton = event.target.closest('[data-toggle-product]');
            if (toggleProductButton) return this.removeProduct(toggleProductButton.dataset.toggleProduct);

            const addEntryButton = event.target.closest('[data-add-entry]');
            if (addEntryButton) return this.addEntry(addEntryButton.dataset.addEntry);

            const removeEntryButton = event.target.closest('[data-remove-entry]');
            if (removeEntryButton) return this.removeEntry(removeEntryButton.dataset.removeEntry);

            const summary = event.target.closest('summary');
            const details = summary?.closest('[data-product-details]');
            if (details) {
              event.preventDefault();
              return this.toggleDetails(details);
            }

            if (event.target.closest('.bundle-tile__panel')) return;
            const selectedTile = event.target.closest('.bundle-tile.is-selected');
            const tileDetails = selectedTile?.querySelector('[data-product-details]');
            if (tileDetails) this.toggleDetails(tileDetails);
          });

          this.grid.addEventListener('toggle', (event) => {
            const details = event.target.closest('[data-product-details]');
            if (!details) return;
            if (details.open) this.openProducts.add(details.dataset.productDetails);
            else this.openProducts.delete(details.dataset.productDetails);
          }, true);

          this.grid.addEventListener('change', (event) => {
            const option = event.target.closest('[data-entry-option]');
            if (option) return this.changeOption(option.dataset.entryKey, Number(option.dataset.optionIndex), option.value);

            const field = event.target.closest('[data-entry-field]');
            if (field) {
              this.updateField(field.dataset.entryKey, field.dataset.fieldKey, field.value);
              this.updateChrome();
              window.clearTimeout(this.fieldRenderTimer);
              this.fieldRenderTimer = window.setTimeout(() => {
                this.fieldRenderTimer = 0;
                if (!this.isSubmitting) this.render();
              }, 180);
            }
          });

          this.grid.addEventListener('input', (event) => {
            const field = event.target.closest('[data-entry-field]');
            if (!field) return;
            this.updateField(field.dataset.entryKey, field.dataset.fieldKey, field.value);
            const counter = field.closest('.bundle-field')?.querySelector('[data-field-count]');
            if (counter) counter.textContent = `${field.value.length}/${field.maxLength}`;
            if (this.hasTriedSubmit) field.setAttribute('aria-invalid', this.fieldMissing(field.dataset.entryKey, field.dataset.fieldKey) ? 'true' : 'false');
            this.updateChrome();
          });

          this.submitButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.submit();
          });
          this.previewToggle?.addEventListener('click', () => this.togglePreview());
          this.previewList?.addEventListener('click', (event) => {
            const removeButton = event.target.closest('[data-preview-remove]');
            if (removeButton) return this.removePreviewEntry(removeButton.dataset.previewRemove);

            const item = event.target.closest('[data-preview-entry]');
            if (item) this.focusPreviewEntry(item.dataset.previewEntry, item.dataset.previewProduct);
          });
        }

        togglePreview() {
          if (!this.preview || !this.previewToggle || this.entries.length === 0) return;
          const expanded = this.previewToggle.getAttribute('aria-expanded') !== 'true';
          this.previewToggle.setAttribute('aria-expanded', String(expanded));
          this.preview.hidden = !expanded;
          requestAnimationFrame(() => this.scheduleBarDock());
        }

        removePreviewEntry(key) {
          const entryIndex = this.entries.findIndex((entry) => entry.key === key);
          const entry = this.entries[entryIndex];
          if (!entry) return;
          const nextEntry = this.entries[entryIndex + 1] || this.entries[entryIndex - 1];
          this.removeEntry(key);
          requestAnimationFrame(() => {
            const nextRemoveButton = nextEntry
              ? this.previewList?.querySelector(`[data-preview-remove="${CSS.escape(nextEntry.key)}"]`)
              : null;
            const productSelectButton = this.querySelector(`[data-select-product="${CSS.escape(entry.productHandle)}"]`);
            (nextRemoveButton || productSelectButton)?.focus();
          });
        }

        focusPreviewEntry(key, handle) {
          const entry = this.entryByKey(key);
          const product = entry ? this.productsByHandle.get(entry.productHandle) : null;
          if (!entry || !product) return;
          const missingField = product.fields.find((field) => field.required && !String(entry.values[field.key] || '').trim());
          this.openProducts.add(handle);
          this.preview.hidden = true;
          this.previewToggle?.setAttribute('aria-expanded', 'false');
          this.render().then(() => {
            requestAnimationFrame(() => {
              const entryNode = this.querySelector(`[data-entry-key="${CSS.escape(key)}"]`);
              let target = missingField
                ? entryNode?.querySelector(`[data-entry-field][data-field-key="${CSS.escape(missingField.key)}"]`)
                : entryNode?.querySelector('select, input, textarea');
              target = target || this.querySelector(`[data-product-details="${CSS.escape(handle)}"] summary`);
              (entryNode || target)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
              window.setTimeout(() => target?.focus({ preventScroll: true }), 320);
            });
          });
        }

        scheduleBarDock() {
          if (this.barDockFrame) return;
          this.barDockFrame = requestAnimationFrame(() => {
            this.barDockFrame = 0;
            this.updateBarDock();
          });
        }

        updateBarDock() {
          if (!this.bar) return;
          if (!this.footer || !this.footer.isConnected) this.footer = document.querySelector('footer.footer, footer');
          const visualViewport = window.visualViewport;
          const visualTop = visualViewport ? Math.max(0, visualViewport.offsetTop) : 0;
          const viewportBottom = visualViewport
            ? visualViewport.offsetTop + visualViewport.height
            : window.innerHeight;
          const visualBottom = Math.max(0, window.innerHeight - viewportBottom);
          const footerTop = this.footer?.getBoundingClientRect().top;
          const footerVisible = Number.isFinite(footerTop) && footerTop <= viewportBottom;
          this.bar.style.setProperty('--bundle-visual-bottom', `${Math.round(visualBottom)}px`);
          this.bar.classList.toggle('is-footer-hidden', footerVisible);
          document.documentElement.style.setProperty('--bundle-visual-top', `${Math.round(visualTop)}px`);
        }

        toggleDetails(details) {
          this.clearValidationState();
          return this.animateLayout(() => {
            details.open = !details.open;
          });
        }

        createEntry(product) {
          const variant = product.variants[0];
          this.keyIndex += 1;
          return {
            key: `${product.handle}-${Date.now()}-${this.keyIndex}`,
            productHandle: product.handle,
            variantId: variant.id,
            options: [...variant.options],
            values: {},
          };
        }

        selectProduct(handle) {
          const product = this.productsByHandle.get(handle);
          if (!product?.usable || this.entries.some((entry) => entry.productHandle === handle)) return;
          this.entries.push(this.createEntry(product));
          this.openProducts.add(handle);
          this.clearValidationState();
          this.render().then(() => {
            requestAnimationFrame(() => this.querySelector(`[data-product-details="${CSS.escape(handle)}"] summary`)?.focus());
          });
        }

        removeProduct(handle) {
          this.entries = this.entries.filter((entry) => entry.productHandle !== handle);
          this.openProducts.delete(handle);
          this.clearValidationState();
          this.render();
        }

        addEntry(handle) {
          const product = this.productsByHandle.get(handle);
          if (!product?.usable) return;
          this.entries.push(this.createEntry(product));
          this.openProducts.add(handle);
          this.clearValidationState();
          this.render();
        }

        removeEntry(key) {
          const entry = this.entryByKey(key);
          if (!entry) return;
          this.entries = this.entries.filter((item) => item.key !== key);
          if (!this.entries.some((item) => item.productHandle === entry.productHandle)) this.openProducts.delete(entry.productHandle);
          this.clearValidationState();
          this.render();
        }

        changeOption(key, optionIndex, value) {
          const entry = this.entryByKey(key);
          const product = entry ? this.productsByHandle.get(entry.productHandle) : null;
          if (!entry || !product) return;

          const nextOptions = [...entry.options];
          nextOptions[optionIndex] = value;
          let variant = product.variants.find((candidate) => candidate.options.every((option, index) => option === nextOptions[index]));
          if (!variant) variant = product.variants.find((candidate) => candidate.options[optionIndex] === value);
          if (!variant) return;
          entry.variantId = variant.id;
          entry.options = [...variant.options];
          this.clearValidationState();
          this.render();
        }

        updateField(key, fieldKey, value) {
          const entry = this.entryByKey(key);
          if (!entry) return;
          entry.values[fieldKey] = String(value || '');
          this.clearValidationState();
        }

        clearValidationState() {
          this.hasTriedSubmit = false;
          this.clearNotice();
          this.grid?.querySelectorAll('[aria-invalid="true"]').forEach((field) => field.setAttribute('aria-invalid', 'false'));
          this.grid?.querySelectorAll('.bundle-entry__error').forEach((error) => error.remove());
        }

        fieldMissing(key, fieldKey) {
          const entry = this.entryByKey(key);
          const product = entry ? this.productsByHandle.get(entry.productHandle) : null;
          const field = product?.fields.find((item) => item.key === fieldKey);
          return Boolean(field?.required && !String(entry.values[fieldKey] || '').trim());
        }

        entryByKey(key) {
          return this.entries.find((entry) => entry.key === key);
        }

        variantForEntry(entry) {
          return this.productsByHandle.get(entry.productHandle)?.variants.find((variant) => variant.id === entry.variantId);
        }

        entryComplete(entry) {
          const product = this.productsByHandle.get(entry.productHandle);
          if (!product || !this.variantForEntry(entry)) return false;
          return product.fields.every((field) => !field.required || String(entry.values[field.key] || '').trim());
        }

        render() {
          const update = () => {
            this.grid.innerHTML = this.products.map((product) => this.renderProduct(product)).join('');
            this.updateChrome();
          };
          const completion = this.animateLayout(update);
          this.hasRendered = true;
          return completion;
        }

        animateLayout(update) {
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (!this.hasRendered || reduceMotion || typeof Element.prototype.animate !== 'function') {
            update();
            return Promise.resolve();
          }

          const before = new Map(
            [...this.grid.querySelectorAll('[data-product-handle]')].map((tile) => [
              tile.dataset.productHandle,
              tile.getBoundingClientRect(),
            ])
          );
          update();
          const animations = [];

          for (const tile of this.grid.querySelectorAll('[data-product-handle]')) {
            const first = before.get(tile.dataset.productHandle);
            const last = tile.getBoundingClientRect();
            if (!first) {
              animations.push(tile.animate([{ opacity: 0.5 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' }));
              continue;
            }
            const deltaX = first.left - last.left;
            const deltaY = first.top - last.top;
            if (Math.abs(deltaX) < 1 && Math.abs(deltaY) < 1) continue;
            animations.push(tile.animate(
              [
                { transform: `translate(${deltaX}px, ${deltaY}px)` },
                { transform: 'translate(0, 0)' },
              ],
              { duration: 280, easing: 'cubic-bezier(0.2, 0.75, 0.25, 1)' }
            ));
          }

          return Promise.all(animations.map((animation) => animation.finished.catch(() => undefined))).then(() => undefined);
        }

        renderProduct(product) {
          const entries = this.entries.filter((entry) => entry.productHandle === product.handle);
          const selected = entries.length > 0;
          const complete = selected && entries.every((entry) => this.entryComplete(entry));
          const image = selected ? this.variantForEntry(entries[0])?.image || product.featuredImage?.src : product.featuredImage?.src;
          const price = selected
            ? this.money(entries.reduce((sum, entry) => sum + (this.variantForEntry(entry)?.price || 0), 0))
            : this.productPrice(product);
          const status = !product.usable
            ? this.strings.unavailable
            : selected
              ? complete ? this.strings.complete : this.strings.needsDetails
              : this.strings.select;
          const imageMarkup = image
            ? `<img class="bundle-tile__image" src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(product.featuredImage?.alt || product.title)}" loading="lazy" width="900" height="1125">`
            : '<span class="bundle-tile__image" aria-hidden="true"></span>';

          if (!selected) {
            const error = product.usable ? '' : this.renderProductError(product);
            return `
              <article class="bundle-tile${product.usable ? '' : ' is-disabled'}" data-product-handle="${this.escapeAttribute(product.handle)}">
                <button class="bundle-tile__select" type="button" data-select-product="${this.escapeAttribute(product.handle)}" role="checkbox" aria-checked="false" ${product.usable ? '' : 'disabled'}>
                  <span class="bundle-tile__media">
                    ${imageMarkup}
                    <span class="bundle-tile__toggle" aria-hidden="true">
                      <span class="bundle-tile__checkbox"></span>
                      <span>${this.escapeHtml(status)}</span>
                    </span>
                  </span>
                  <span class="bundle-tile__copy">
                    <span class="bundle-tile__title">${this.escapeHtml(product.title)}</span>
                    <span class="bundle-tile__price">${this.escapeHtml(price)}</span>
                    <span class="bundle-tile__status">${this.escapeHtml(status)}</span>
                  </span>
                </button>
                ${error}
              </article>`;
          }

          return `
            <article class="bundle-tile is-selected" data-product-handle="${this.escapeAttribute(product.handle)}">
              <div class="bundle-tile__selected-visual">
                <div class="bundle-tile__media">
                  ${imageMarkup}
                </div>
                <div class="bundle-tile__expanded-copy">
                  <span class="bundle-tile__title">${this.escapeHtml(product.title)}</span>
                  <span class="bundle-tile__price">${this.escapeHtml(price)}</span>
                </div>
              </div>
              <button
                class="bundle-tile__toggle is-on"
                type="button"
                data-toggle-product="${this.escapeAttribute(product.handle)}"
                  role="checkbox"
                aria-checked="true"
                aria-label="${this.escapeAttribute(this.template(this.strings.removeItem, { title: product.title }))}"
              >
                <span class="bundle-tile__checkbox" aria-hidden="true"></span>
                <span>${this.escapeHtml(this.strings.selected)}</span>
              </button>
              <details data-product-details="${this.escapeAttribute(product.handle)}" ${this.openProducts.has(product.handle) ? 'open' : ''}>
                <summary class="bundle-tile__summary">
                  <span class="bundle-tile__title">${this.escapeHtml(product.title)}</span>
                  <span class="bundle-tile__price">${this.escapeHtml(price)}</span>
                  <span class="bundle-tile__status${complete ? '' : ' bundle-tile__status--needs-details'}">${this.escapeHtml(status)}</span>
                </summary>
                <div class="bundle-tile__panel" aria-label="${this.escapeAttribute(this.template(this.strings.configurationFor, { title: product.title }))}">
                  ${entries.map((entry, index) => this.renderEntry(product, entry, index, entries.length)).join('')}
                  <button class="bundle-entry__add" type="button" data-add-entry="${this.escapeAttribute(product.handle)}">+ ${this.escapeHtml(this.strings.addAnother)}</button>
                </div>
              </details>
            </article>`;
        }

        renderProductError(product) {
          let message = this.strings.unavailable;
          if (product.configError) {
            message = this.config.designMode
              ? `${this.strings.invalidConfig} ${product.configError}`
              : this.strings.invalidConfig;
          }
          return `<div class="bundle-tile__error" role="alert">${this.escapeHtml(message)}</div>`;
        }

        renderEntry(product, entry, index, count) {
          const heading = count > 1 ? this.template(this.strings.itemNumber, { number: index + 1 }) : this.strings.customize;
          const fields = product.fields.map((field) => this.renderField(entry, field)).join('');
          const options = !product.hasOnlyDefaultVariant && product.optionNames.length > 0
            ? product.optionNames.map((name, optionIndex) => this.renderOption(product, entry, name, optionIndex)).join('')
            : '';
          const hasError = this.hasTriedSubmit && !this.entryComplete(entry);
          return `
            <div class="bundle-entry" data-entry-key="${this.escapeAttribute(entry.key)}">
              <div class="bundle-entry__head">
                <strong>${this.escapeHtml(heading)}</strong>
                <button class="bundle-entry__remove" type="button" data-remove-entry="${this.escapeAttribute(entry.key)}">${this.escapeHtml(this.strings.remove)}</button>
              </div>
              ${options}
              ${fields}
              ${hasError ? `<div class="bundle-entry__error" role="alert">${this.escapeHtml(this.strings.completeRequired)}</div>` : ''}
            </div>`;
        }

        renderOption(product, entry, name, optionIndex) {
          const values = [...new Set(product.variants.map((variant) => variant.options[optionIndex]).filter(Boolean))];
          if (values.length === 1) {
            return `
              <div class="bundle-field bundle-field--fixed">
                <span class="bundle-field__label">${this.escapeHtml(name)}</span>
                <strong>${this.escapeHtml(values[0])}</strong>
              </div>`;
          }
          const options = values.map((value) => {
            return `<option value="${this.escapeAttribute(value)}" ${entry.options[optionIndex] === value ? 'selected' : ''}>${this.escapeHtml(value)}</option>`;
          }).join('');
          return `
            <div class="bundle-field">
              <label for="bundle-option-${this.escapeAttribute(entry.key)}-${optionIndex}">${this.escapeHtml(name)}</label>
              <select id="bundle-option-${this.escapeAttribute(entry.key)}-${optionIndex}" data-entry-option data-entry-key="${this.escapeAttribute(entry.key)}" data-option-index="${optionIndex}">${options}</select>
            </div>`;
        }

        renderField(entry, field) {
          const id = `bundle-field-${entry.key}-${field.key}`;
          const value = String(entry.values[field.key] || '');
          const invalid = this.hasTriedSubmit && field.required && !value.trim();
          const required = field.required ? `<span class="bundle-field__required" aria-hidden="true">*</span><span class="visually-hidden">${this.escapeHtml(this.strings.required)}</span>` : '';
          const shared = `id="${this.escapeAttribute(id)}" data-entry-field data-entry-key="${this.escapeAttribute(entry.key)}" data-field-key="${this.escapeAttribute(field.key)}" aria-invalid="${invalid ? 'true' : 'false'}" ${field.required ? 'required' : ''}`;
          let control = '';

          if (field.type === 'textarea') {
            control = `<textarea ${shared} maxlength="${field.maxLength}" placeholder="${this.escapeAttribute(field.placeholder)}">${this.escapeHtml(value)}</textarea><span class="bundle-field__meta" data-field-count>${value.length}/${field.maxLength}</span>`;
          } else if (field.type === 'select') {
            const options = field.options.map((option) => `<option value="${this.escapeAttribute(option)}" ${value === option ? 'selected' : ''}>${this.escapeHtml(option)}</option>`).join('');
            control = `<select ${shared}><option value="">${this.escapeHtml(field.placeholder || this.strings.selectPlaceholder)}</option>${options}</select>`;
          } else {
            const type = field.type === 'date' ? 'date' : 'text';
            const length = type === 'text' ? `maxlength="${field.maxLength}"` : '';
            control = `<input ${shared} type="${type}" value="${this.escapeAttribute(value)}" placeholder="${this.escapeAttribute(field.placeholder)}" ${length}>`;
            if (type === 'text') control += `<span class="bundle-field__meta" data-field-count>${value.length}/${field.maxLength}</span>`;
          }

          return `<div class="bundle-field"><label for="${this.escapeAttribute(id)}">${this.escapeHtml(field.label)} ${required}</label>${control}</div>`;
        }

        productPrice(product) {
          if (product.variants.length === 0) return this.strings.unavailable;
          const prices = product.variants.map((variant) => variant.price);
          const minimum = Math.min(...prices);
          const maximum = Math.max(...prices);
          if (minimum === maximum) return this.money(minimum);
          return this.template(this.strings.fromPrice, { price: this.money(minimum) });
        }

        updatePreview() {
          if (!this.preview || !this.previewList) return;
          if (this.previewToggle) this.previewToggle.hidden = this.entries.length === 0;
          if (this.entries.length === 0) {
            this.preview.hidden = true;
            this.previewToggle?.setAttribute('aria-expanded', 'false');
            this.previewList.innerHTML = '';
            return;
          }

          this.previewList.innerHTML = this.entries.map((entry) => {
            const product = this.productsByHandle.get(entry.productHandle);
            const variant = this.variantForEntry(entry);
            if (!product || !variant) return '';
            const matchingEntries = this.entries.filter((item) => item.productHandle === entry.productHandle);
            const itemIndex = matchingEntries.findIndex((item) => item.key === entry.key) + 1;
            const itemSuffix = matchingEntries.length > 1
              ? ` · ${this.template(this.strings.itemNumber, { number: itemIndex })}`
              : '';
            const variantText = product.hasOnlyDefaultVariant
              ? ''
              : variant.options.filter(Boolean).join(' / ');
            const properties = product.fields.map((field) => {
              const value = String(entry.values[field.key] || '').trim();
              if (!value) return '';
              return `<span><strong>${this.escapeHtml(field.label)}:</strong> ${this.escapeHtml(value)}</span>`;
            }).filter(Boolean).join('');
            const needsDetails = !this.entryComplete(entry);
            const itemName = `${product.title}${itemSuffix}`;

            return `
              <div class="bundle-builder__cart-preview-item">
                <button
                  class="bundle-builder__cart-preview-details"
                  type="button"
                  data-preview-entry="${this.escapeAttribute(entry.key)}"
                  data-preview-product="${this.escapeAttribute(product.handle)}"
                >
                  <span class="bundle-builder__cart-preview-copy">
                    <span class="bundle-builder__cart-preview-title">${this.escapeHtml(itemName)}</span>
                    ${variantText ? `<span class="bundle-builder__cart-preview-variant">${this.escapeHtml(variantText)}</span>` : ''}
                    ${properties ? `<span class="bundle-builder__cart-preview-properties">${properties}</span>` : ''}
                    ${needsDetails ? `<span class="bundle-builder__cart-preview-needs">${this.escapeHtml(this.strings.needsDetails)}</span>` : ''}
                  </span>
                </button>
                <span class="bundle-builder__cart-preview-actions">
                  <span class="bundle-builder__cart-preview-price">${this.escapeHtml(this.money(variant.price || 0))}</span>
                  <button
                    class="bundle-builder__cart-preview-remove"
                    type="button"
                    data-preview-remove="${this.escapeAttribute(entry.key)}"
                    aria-label="${this.escapeAttribute(this.template(this.strings.removeItem, { title: itemName }))}"
                  >${this.escapeHtml(this.strings.remove)}</button>
                </span>
              </div>`;
          }).join('');
        }

        updateChrome() {
          const count = this.entries.length;
          const subtotal = this.entries.reduce((sum, entry) => sum + (this.variantForEntry(entry)?.price || 0), 0);
          const money = this.money(subtotal);
          const allComplete = count > 0 && this.entries.every((entry) => this.entryComplete(entry));
          const activeStep = count === 0 ? 1 : allComplete ? 3 : 2;
          this.countNode.textContent = this.template(count === 1 ? this.strings.itemOne : this.strings.itemMany, { count });
          this.subtotalNode.textContent = money;
          this.submitButton.textContent = this.isSubmitting
            ? this.strings.adding
            : this.strings.addToCart;
          this.submitButton.disabled = this.isSubmitting || count === 0;
          this.submitButton.classList.toggle('is-loading', this.isSubmitting);
          this.submitButton.setAttribute('aria-busy', String(this.isSubmitting));
          this.updatePreview();
          this.dataset.journeyStep = String(activeStep);
          this.journeySteps.forEach((step) => {
            const stepNumber = Number(step.dataset.bundleStep);
            step.classList.toggle('is-active', stepNumber === activeStep);
            step.classList.toggle('is-complete', stepNumber < activeStep);
            if (stepNumber === activeStep) step.setAttribute('aria-current', 'step');
            else step.removeAttribute('aria-current');
          });
          this.scheduleBarDock();
        }

        async submit() {
          if (this.isSubmitting) return;
          this.hasTriedSubmit = true;
          if (this.entries.length === 0) {
            this.showNotice(this.strings.selectAtLeastOne);
            return;
          }

          const incomplete = this.entries.find((entry) => !this.entryComplete(entry));
          if (incomplete) {
            this.openProducts.add(incomplete.productHandle);
            this.showNotice(this.strings.completeRequired);
            this.render().then(() => {
              requestAnimationFrame(() => {
                const target = this.querySelector(`[data-entry-key="${CSS.escape(incomplete.key)}"] [aria-invalid="true"]`) || this.querySelector(`[data-entry-key="${CSS.escape(incomplete.key)}"]`);
                target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
                if (target?.focus) window.setTimeout(() => target.focus({ preventScroll: true }), 250);
              });
            });
            return;
          }

          this.isSubmitting = true;
          this.clearNotice();
          this.updateChrome();
          const groupId = `${this.config.shellHandle}-${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
          const items = this.entries.map((entry, index) => ({
            id: entry.variantId,
            quantity: 1,
            properties: this.propertiesForEntry(entry, groupId, index),
          }));
          const cartDrawer = document.querySelector('cart-drawer');
          const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];
          const cartAddRoute = window.routes?.cart_add_url || '/cart/add';
          const cartAddUrl = cartAddRoute.endsWith('.js') ? cartAddRoute : `${cartAddRoute}.js`;
          const requestBody = JSON.stringify({ items, sections, sections_url: window.location.pathname });
          cartDrawer?.setActiveElement(this.submitButton);

          try {
            const payload = await this.requestBundleAdd(cartAddUrl, requestBody, groupId);
            this.showNotice(this.strings.added, 'success');
            if (cartDrawer && payload?.sections) {
              cartDrawer.renderContents({ id: items[0].id, sections: payload.sections });
            } else if (cartDrawer) {
              await this.refreshCartDrawer(cartDrawer, items[0].id);
            } else {
              window.location.assign(window.routes?.cart_url || '/cart');
            }
          } catch (error) {
            this.showNotice(error.message || this.strings.cartError);
          } finally {
            this.isSubmitting = false;
            this.updateChrome();
          }
        }

        async requestBundleAdd(url, body, groupId, attempt = 0) {
          const response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            credentials: 'same-origin',
            body,
          });
          const responseText = await response.text();
          let payload;

          try {
            payload = JSON.parse(responseText);
          } catch (error) {
            if (await this.cartContainsGroup(groupId)) return null;
            if (attempt === 0) return this.requestBundleAdd(url, body, groupId, 1);
            throw new Error(this.strings.cartError);
          }

          if (!response.ok || payload.status) {
            throw new Error(payload.description || payload.message || this.strings.cartError);
          }
          return payload;
        }

        async cartContainsGroup(groupId) {
          try {
            const cartUrl = window.routes?.cart_url || '/cart';
            const cartStateUrl = cartUrl.endsWith('.js') ? cartUrl : `${cartUrl}.js`;
            const response = await fetch(cartStateUrl, {
              headers: { Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store',
            });
            if (!response.ok) return false;
            const cartState = await response.json();
            return Boolean(cartState.items?.some((item) => item.properties?._bundle_group_id === groupId));
          } catch (error) {
            return false;
          }
        }

        async refreshCartDrawer(cartDrawer, variantId) {
          const sectionIds = cartDrawer.getSectionsToRender().map((section) => section.id);
          const sectionUrl = new URL(window.location.href);
          sectionUrl.searchParams.set('sections', sectionIds.join(','));
          const response = await fetch(sectionUrl.toString(), {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin',
            cache: 'no-store',
          });
          if (!response.ok) throw new Error(this.strings.cartError);
          const responseText = await response.text();
          let sections;
          try {
            sections = JSON.parse(responseText);
          } catch (error) {
            throw new Error(this.strings.cartError);
          }
          cartDrawer.renderContents({ id: variantId, sections });
        }

        propertiesForEntry(entry, groupId, index) {
          const product = this.productsByHandle.get(entry.productHandle);
          const variant = this.variantForEntry(entry);
          const properties = new Map();
          const setProperty = (label, value) => {
            const canonicalLabel = this.normalizePropertyToken(label);
            const existing = properties.get(canonicalLabel);
            if (existing) existing.value = value;
            else properties.set(canonicalLabel, { label, value });
          };

          setProperty('_bundle_group_id', groupId);
          setProperty('_bundle_parent', this.config.shellTitle);
          setProperty('_bundle_parent_handle', this.config.shellHandle);
          setProperty('_bundle_item', String(index + 1));
          this.resolveFixedLineItemProperties(product.fixedLineItemProperties, variant).forEach((property) => {
            setProperty(property.label, property.value);
          });
          this.resolveFixedLineItemProperties(product.bundleFixedLineItemProperties, variant).forEach((property) => {
            setProperty(property.label, property.value);
          });
          product.fields.forEach((field) => {
            const value = String(entry.values[field.key] || '').trim();
            if (value) setProperty(field.label, value);
          });
          return Object.fromEntries([...properties.values()].map((property) => [property.label, property.value]));
        }

        showNotice(message, type = 'error') {
          const isSuccess = type === 'success';
          this.notice.textContent = message;
          this.notice.classList.toggle('is-success', isSuccess);
          this.notice.classList.toggle('is-error', !isSuccess);
          this.notice.setAttribute('role', isSuccess ? 'status' : 'alert');
          this.notice.setAttribute('aria-live', isSuccess ? 'polite' : 'assertive');
          this.notice.hidden = false;
        }

        clearNotice() {
          if (!this.notice) return;
          this.notice.textContent = '';
          this.notice.classList.remove('is-success', 'is-error');
          this.notice.setAttribute('role', 'status');
          this.notice.setAttribute('aria-live', 'polite');
          this.notice.hidden = true;
        }

        money(cents) {
          return new Intl.NumberFormat(this.config.locale || document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.config.currencyCode || 'USD',
          }).format(Number(cents || 0) / 100);
        }

        template(value, replacements) {
          return Object.entries(replacements).reduce((result, [key, replacement]) => result.replace(`[${key}]`, String(replacement)), String(value || ''));
        }

        escapeHtml(value) {
          return String(value ?? '').replace(/[&<>'"]/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
        }

        escapeAttribute(value) {
          return this.escapeHtml(value);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
